<script>
import logo from "@/assets/images/seda/logo-s.png";
import pattern from "@/assets/images/seda/patrn.png";
import favicon from "@/assets/images/seda/logo-1.png";
import primeMinisterLogo from "@/assets/images/seda/Coat_of_arms_of_Iraq.svg";
import tradeMinistryLogo from "@/assets/images/seda/Ministry_of_Trade_of_Iraq.png";
import communicationsMinistryLogo from "@/assets/images/seda/moc-lockup.svg";
import popularMobilizationLogo from "@/assets/images/seda/hashed.svg";
import relationsDirectorateLogo from "@/assets/images/seda/elaqat.svg";
import spotLogo from "@/assets/images/seda/spot.png";
import tebyeenLogo from "@/assets/images/seda/tebyeen.png";
import ilyaLogo from "@/assets/images/seda/ilya.png";

export default {
  data() {
    return {
      logo,
      pattern,
      videoUrl: "",
      previousTitle: "",
      previousFavicon: "",
      sponsors: [
        {
          title: "رئاسة مجلس الوزراء",
          subtitle: "بدعم",
          logo: primeMinisterLogo,
        },
        {
          title: "وزارة التجارة",
          subtitle: "بدعم",
          logo: tradeMinistryLogo,
        },
        {
          title: "وزارة الاتصالات",
          subtitle: "بدعم",
          logo: communicationsMinistryLogo,
        },
        {
          title: "هيئة الحشد الشعبي",
          subtitle: "بدعم",
          logo: popularMobilizationLogo,
        },
        {
          title: "المديرية العامة للعلاقات والخدمات الاجتماعية",
          subtitle: "بدعم",
          logo: relationsDirectorateLogo,
        },
        {
          title: "سبوت كافيه",
          subtitle: "بدعم",
          logo: spotLogo,
        },
        {
          title: "تبيين",
          subtitle: "بدعم",
          logo: tebyeenLogo,
        },
        {
          title: "ILYA KIDS",
          subtitle: "بدعم",
          logo: ilyaLogo,
        },
      ],
    };
  },
  mounted() {
    this.previousTitle = document.title;
    document.title = "معرض المشاريع النسائية الوطني 2026 | سيدة العالم";
    const icon = document.querySelector("link[rel~='icon']");
    if (icon) {
      this.previousFavicon = icon.href;
      icon.href = favicon;
    }
  },
  beforeDestroy() {
    document.title = this.previousTitle;
    const icon = document.querySelector("link[rel~='icon']");
    if (icon && this.previousFavicon) icon.href = this.previousFavicon;
  },
};
</script>

<template>
  <main class="expo-page" dir="rtl">
    <header class="topbar">
      <div class="container topbar-inner">
        <a href="#home" class="brand" aria-label="سيدة العالم، الرئيسية">
          <img :src="logo" alt="شعار سيدة العالم" />
        </a>
        <nav class="main-nav" aria-label="القائمة الرئيسية">
          <a href="#about">عن المعرض</a>
          <a href="#visit">معلومات الزيارة</a>
          <a href="#video">جولة القاعة</a>
          <a href="#booths">أنواع البوثات</a>
          <a href="#sponsors">الرعاة</a>
        </nav>
        <router-link class="nav-cta" to="/projects-exhibition/projects">
          استمارة التسجيل <i class="fas fa-arrow-left" aria-hidden="true"></i>
        </router-link>
      </div>
    </header>

    <section id="home" class="hero">
      <div class="hero-pattern" :style="{ backgroundImage: `url(${pattern})` }"></div>
      <div class="hero-wash" aria-hidden="true"></div>
      <div class="container hero-layout">
        <div class="hero-copy">
          <span class="eyebrow"
            ><i class="fas fa-sparkles"></i> إبداع نسائي · فرص وطنية</span
          >
          <h1>معرض المشاريع<br /><em>النسائية الوطني</em><b>2026</b></h1>
          <p class="hero-intro">
            انضمي إلى مساحة تجمع المشاريع النسائية العراقية، وتفتح أمامكِ فرصاً للعرض
            والتواصل والوصول إلى جمهور جديد.
          </p>
          <div class="hero-buttons">
            <router-link class="button button-orange" to="/projects-exhibition/projects">
              سجّلي مشروعكِ الآن <i class="fas fa-arrow-left" aria-hidden="true"></i>
            </router-link>
          </div>
          <div class="hero-facts">
            <span><i class="far fa-calendar-alt"></i> من 4 الى 11 كانون الأول 2026</span>
            <span
              ><i class="fas fa-map-marker-alt"></i> معرض بغداد الدولي · القاعة 17</span
            >
          </div>
        </div>
        <div class="hero-visual" aria-label="هوية معرض المشاريع النسائية الوطني 2026">
          <span class="visual-ring ring-a"></span>
          <span class="visual-ring ring-b"></span>
          <span class="visual-orb"></span>
          <img class="hero-logo" :src="logo" alt="سيدة العالم" />
          <div class="visual-date">
            <strong>08</strong><span>أيام من<br />الإلهام</span>
          </div>
          <div class="visual-caption">
            <i class="fas fa-heart"></i> مشروعكِ يستحق أن يُرى
          </div>
        </div>
      </div>
      <a class="scroll-down" href="#about" aria-label="انتقلي إلى القسم التالي"
        ><span></span
      ></a>
    </section>

    <section id="about" class="section about-section">
      <div class="container about-layout">
        <div class="section-copy">
          <span class="section-label">أهلاً بكِ في مساحتكِ</span>
          <h2>كل مشروع عظيم<br /><em>يستحق فرصة للظهور</em></h2>
          <p>
            مرحباً بكِ في معرض التسجيل للمشاركة في معرض المشاريع النسائية الوطني 2026،
            الذي تنظمه مؤسسة سيدة العالم النسائية، برعاية رئيس مجلس الوزراء المحترم، بهدف
            دعم المشاريع النسائية الناشئة والقائمة، وإتاحة الفرصة لعرض منتجاتها، والوصول
            إلى جمهور أوسع، وبناء فرص جديدة للتواصل والنمو.
          </p>
          <p>
            نرحب بالمشاريع النسائية من مختلف أنحاء العراق لتكون جزءاً من تجربة تجمع
            الإبداع والمنتجات المميزة والفرص الواعدة.
          </p>
          <router-link class="inline-link" to="/projects-exhibition/projects">
            ابدئي التسجيل <i class="fas fa-long-arrow-alt-left" aria-hidden="true"></i>
          </router-link>
        </div>
        <div id="visit" class="event-card">
          <div class="event-heading">
            <span class="event-symbol"><i class="far fa-calendar-check"></i></span>
            <div>
              <small>خططي لزيارتكِ</small>
              <h3>معلومات المعرض</h3>
            </div>
          </div>
          <div class="event-row">
            <span class="event-icon"><i class="far fa-calendar-alt"></i></span>
            <div><small>موعد الافتتاح</small><strong>4 كانون الأول 2026</strong></div>
          </div>
          <div class="event-row">
            <span class="event-icon"><i class="far fa-clock"></i></span>
            <div>
              <small>مدة المعرض</small><strong>8 أيام · حتى 11 كانون الأول</strong>
            </div>
          </div>
          <div class="event-row">
            <span class="event-icon"><i class="fas fa-map-marker-alt"></i></span>
            <div>
              <small>المكان</small><strong>معرض بغداد الدولي · القاعة رقم 17</strong>
            </div>
          </div>
          <div class="event-message">
            <i class="fas fa-info-circle"></i>
            <span
              >تتم مراجعة طلبات التسجيل من قبلنا والتواصل مع المشاريع المختارة لاستكمال
              إجراءات المشاركة.</span
            >
          </div>
        </div>
      </div>
    </section>

    <!-- <section id="video" class="section video-section">
      <div class="container">
        <div class="section-heading">
          <span class="section-label">اكتشفي المكان</span>
          <h2>جولة في <em>المعرض</em></h2>
          <p>شاهدي القاعة ومواقع البوثات ومرافق المعرض في جولة مرئية كاملة.</p>
        </div>
        <div class="video-stage">
          <video v-if="videoUrl" class="expo-video" controls playsinline :src="videoUrl">
            متصفحك لا يدعم عرض الفيديو.
          </video>
          <div
            v-else
            class="video-placeholder"
            :style="{
              backgroundImage: `linear-gradient(120deg, rgba(28,85,91,.83), rgba(39,155,164,.75)), url(${pattern})`,
            }"
          >
            <span class="play-circle"
              ><i class="fas fa-play" aria-hidden="true"></i
            ></span>
            <strong>جولة القاعة ومواقع البوثات</strong>
            <span>سيُضاف فيديو المعرض هنا قريباً</span>
          </div>
          <div class="video-tag">
            <i class="fas fa-video"></i> معرض بغداد الدولي · القاعة 17
          </div>
        </div>
      </div>
    </section> -->

    <section class="section benefits-section" aria-labelledby="benefits-title">
      <div class="container">
        <div class="section-heading">
          <span class="section-label">مشاركتكِ... خطوة نحو فرص أكبر</span>
          <h2 id="benefits-title">لماذا <em>تشاركين؟</em></h2>
        </div>
        <div class="benefits-grid">
          <article class="benefit-card">
            <span class="benefit-icon"
              ><i class="fas fa-users" aria-hidden="true"></i
            ></span>
            <h3>جمهور جديد</h3>
            <p>عرّفي الزوار بمشروعكِ ومنتجاتكِ.</p>
          </article>
          <article class="benefit-card">
            <span class="benefit-icon"
              ><i class="fas fa-handshake" aria-hidden="true"></i
            ></span>
            <h3>علاقات وفرص</h3>
            <p>تواصلي مع مشاريع وجهات مهتمة.</p>
          </article>
          <article class="benefit-card">
            <span class="benefit-icon"
              ><i class="fas fa-store" aria-hidden="true"></i
            ></span>
            <h3>حضور مباشر</h3>
            <p>اعرضي منتجاتكِ على أرض الواقع.</p>
          </article>
          <article class="benefit-card">
            <span class="benefit-icon"
              ><i class="fas fa-bullhorn" aria-hidden="true"></i
            ></span>
            <h3>تعريف بمشروعكِ</h3>
            <p>امنحي علامتكِ فرصة أكبر للظهور.</p>
          </article>
        </div>
      </div>
    </section>

    <section id="booths" class="section booth-section">
      <div class="container">
        <div class="section-heading">
          <span class="section-label">مساحتكِ على قدر طموحكِ</span>
          <h2>اختاري <em>نمط البوث</em></h2>
          <p>
            السعر يشمل كامل أيام المعرض الثمانية، إضافةً إلى التقطيع والفرش وتوفير
            الكهرباء.
          </p>
        </div>
        <div class="booth-grid">
          <article class="booth-card booth-a">
            <div class="booth-top">
              <span class="booth-type">A</span><span class="booth-tag">مساحة أوسع</span>
            </div>
            <h3>النمط A</h3>
            <p class="booth-description">
              مساحة رحبة تمنح منتجاتكِ مجالاً أكبر للعرض والتعريف.
            </p>
            <div class="booth-measure">
              <i class="fas fa-vector-square"></i><strong>3 × 3.5</strong><span>متر</span>
            </div>
            <div class="booth-price">
              <strong>500,000</strong><span>دينار عراقي</span>
            </div>
            <div class="booth-includes">
              <i class="fas fa-check-circle"></i> التقطيع والفرش وتوفير الكهرباء
            </div>
          </article>
          <article class="booth-card booth-b">
            <div class="booth-top">
              <span class="booth-type">B</span><span class="booth-tag">مساحة عملية</span>
            </div>
            <h3>النمط B</h3>
            <p class="booth-description">
              خيار عملي لتقديم مشروعكِ والتواصل مع زوار المعرض.
            </p>
            <div class="booth-measure">
              <i class="fas fa-vector-square"></i><strong>2 × 3</strong><span>متر</span>
            </div>
            <div class="booth-price">
              <strong>300,000</strong><span>دينار عراقي</span>
            </div>
            <div class="booth-includes">
              <i class="fas fa-check-circle"></i> التقطيع والفرش وتوفير الكهرباء
            </div>
          </article>
        </div>
        <p class="booth-footnote">
          <i class="fas fa-info-circle"></i> يتم اختيار موقع البوث وتأكيد التوفر ضمن
          استمارة التسجيل.
        </p>
      </div>
    </section>

    <section id="sponsors" class="section sponsor-section">
      <div class="container">
        <div class="section-heading">
          <span class="section-label">بشراكة وطنية</span>
          <h2>بدعم <em>شركائنا</em></h2>
          <p>نعتز برعاية الجهات الوطنية الداعمة للمشاريع النسائية.</p>
        </div>
        <div class="sponsor-grid">
          <article
            v-for="sponsor in sponsors"
            :key="sponsor.title"
            class="sponsor-card"
          >
            <div class="sponsor-logo">
              <img :src="sponsor.logo" :alt="`شعار ${sponsor.title}`" />
            </div>
            <span>{{ sponsor.subtitle }}</span>
            <strong>{{ sponsor.title }}</strong>
          </article>
        </div>
      </div>
    </section>

    <section class="final-cta">
      <div class="container final-cta-inner">
        <div>
          <span class="section-label">فرصتكِ تبدأ بخطوة</span>
          <h2>خلي مشروعكِ يوصل أبعد</h2>
          <p>كوني جزءاً من معرض المشاريع النسائية الوطني 2026.</p>
        </div>
        <router-link class="button button-orange" to="/projects-exhibition/projects"
          >انتقلي إلى استمارة التسجيل <i class="fas fa-arrow-left" aria-hidden="true"></i
        ></router-link>
      </div>
    </section>

    <section class="contact-strip" aria-label="معلومات التواصل">
      <div class="container contact-strip-inner">
        <span class="contact-prompt">للاستفسار والتواصل</span>
        <a class="contact-item" href="tel:07877158690" dir="ltr">
          <i class="fas fa-phone-alt" aria-hidden="true"></i>
          07877158690
        </a>
        <a
          class="contact-item"
          href="https://www.instagram.com/ladyoftheworld1?obrf=MWh3NzNyNnl0aW10dA=="
          target="_blank"
          rel="noopener noreferrer"
          dir="ltr"
        >
          <i class="fab fa-instagram" aria-hidden="true"></i>
          Instagram
        </a>
      </div>
    </section>

    <footer class="footer2">
      <div class="container footer-inner">
        <img :src="logo" alt="شعار مؤسسة سيدة العالم" />
        <p>مؤسسة سيدة العالم · مساحة للإبداع وفرص للنمو</p>
        <span>© 2026 جميع الحقوق محفوظة</span>
      </div>
    </footer>
  </main>
</template>

<style scoped>
.expo-page {
  --teal: #5dbfc9;
  --teal-dark: #238f9a;
  --orange: #f08642;
  --ink: #243746;
  --muted: #6f7f8e;
  --line: #e7edef;
  color: var(--ink);
  overflow: hidden;
  line-height: 1.8;
}

.container {
  width: min(1120px, calc(100% - 40px));
  margin: 0 auto;
}
.topbar {
  position: absolute;
  z-index: 10;
  top: 0;
  right: 0;
  left: 0;
  padding: 14px 0;
}
.topbar-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.4rem;
}
.brand {
  display: inline-flex;
  align-items: center;
  flex: 0 0 auto;
}
.brand img {
  display: block;
  width: 150px;
  height: 55px;
  object-fit: contain;
}
.main-nav {
  display: flex;
  align-items: center;
  gap: clamp(0.7rem, 1.6vw, 1.5rem);
}
.main-nav a {
  color: #536879;
  font-size: 0.83rem;
  font-weight: 700;
  text-decoration: none;
  transition: color 0.2s ease;
}
.main-nav a:hover {
  color: var(--teal-dark);
}
.nav-cta,
.button,
.booth-cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.55rem;
  border-radius: 999px;
  font-weight: 800;
  text-decoration: none;
  transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}
.nav-cta {
  padding: 0.55rem 1rem;
  background: var(--teal);
  color: #fff;
  font-size: 0.82rem;
}
.nav-cta:hover,
.button:hover,
.booth-cta:hover {
  color: #fff;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(45, 133, 143, 0.2);
}

.hero {
  position: relative;
  display: flex;
  min-height: 680px;
  align-items: center;
  padding: 100px 0 75px;
  background: linear-gradient(125deg, #f6fcfc 0%, #f1fbfb 58%, #fff8f1 100%);
}
.hero-pattern {
  position: absolute;
  inset: 0;
  background-position: center;
  background-repeat: repeat;
  background-size: 370px auto;
  opacity: 0.16;
  pointer-events: none;
}
.hero-wash {
  position: absolute;
  inset: 0;
  background: radial-gradient(
      ellipse at 82% 55%,
      rgba(93, 191, 201, 0.16),
      transparent 36%
    ),
    radial-gradient(ellipse at 8% 82%, rgba(240, 134, 66, 0.12), transparent 32%);
  pointer-events: none;
}
.hero-layout {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  align-items: center;
  gap: 2rem;
}
.hero-copy {
  max-width: 650px;
}
.eyebrow,
.section-label {
  color: var(--teal-dark);
  font-size: 0.82rem;
  font-weight: 800;
}
.eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  margin-bottom: 0.85rem;
  padding: 0.3rem 0.75rem;
  border: 1px solid rgba(93, 191, 201, 0.25);
  border-radius: 99px;
  background: rgba(255, 255, 255, 0.7);
}
.eyebrow i {
  color: var(--orange);
}
.hero h1 {
  margin: 0 0 0.85rem;
  color: var(--ink);
  font-size: clamp(2.35rem, 5vw, 4.35rem);
  font-weight: 900;
  line-height: 1.22;
}
.hero h1 em {
  color: var(--teal-dark);
  font-style: normal;
}
.hero h1 b {
  display: inline-block;
  margin-right: 0.55rem;
  color: var(--orange);
  font-size: 0.78em;
}
.hero-intro {
  max-width: 590px;
  margin: 0;
  color: #5f7381;
  font-size: 1rem;
  line-height: 2;
}
.hero-buttons {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.8rem 1.25rem;
  margin-top: 1.5rem;
}
.button {
  min-height: 48px;
  padding: 0.65rem 1.2rem;
}
.button-orange {
  background: var(--orange);
  color: #fff;
  box-shadow: 0 7px 17px rgba(240, 134, 66, 0.2);
}
.button-orange:hover {
  background: #e87934;
}
.button-quiet {
  color: #45747a;
}
.hero-facts {
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem 1.2rem;
  margin-top: 1.6rem;
  color: #637787;
  font-size: 0.78rem;
}
.hero-facts span {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
}
.hero-facts i {
  color: var(--orange);
}
.hero-visual {
  position: relative;
  display: grid;
  min-height: 390px;
  place-items: center;
}
.visual-orb {
  position: absolute;
  width: min(350px, 80%);
  aspect-ratio: 1;
  border-radius: 37% 63% 60% 40% / 45% 45% 55% 55%;
  background: linear-gradient(145deg, rgba(93, 191, 201, 0.2), rgba(240, 134, 66, 0.13));
  transform: rotate(-15deg);
}
.visual-ring {
  position: absolute;
  border: 1px solid rgba(93, 191, 201, 0.4);
  border-radius: 50%;
}
.ring-a {
  width: min(410px, 95%);
  height: 245px;
  transform: rotate(25deg);
}
.ring-b {
  width: min(420px, 95%);
  height: 270px;
  border-color: rgba(240, 134, 66, 0.3);
  transform: rotate(-35deg);
}
.hero-logo {
  position: relative;
  z-index: 1;
  width: min(280px, 67%);
  max-height: 150px;
  object-fit: contain;
  filter: drop-shadow(0 12px 18px rgba(34, 101, 110, 0.12));
}
.visual-date,
.visual-caption {
  position: absolute;
  z-index: 2;
  display: flex;
  align-items: center;
  gap: 0.55rem;
  border: 1px solid #e7eded;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 8px 22px rgba(37, 76, 83, 0.1);
}
.visual-date {
  right: 5%;
  bottom: 8%;
  padding: 0.45rem 0.7rem;
  border-radius: 12px;
}
.visual-date strong {
  color: var(--teal-dark);
  font-size: 1.25rem;
}
.visual-date span {
  color: var(--muted);
  font-size: 0.68rem;
  line-height: 1.35;
}
.visual-caption {
  bottom: 15%;
  left: 1%;
  padding: 0.45rem 0.75rem;
  border-radius: 99px;
  color: #526e78;
  font-size: 0.72rem;
  font-weight: 700;
}
.visual-caption i {
  color: var(--orange);
}
.scroll-down {
  position: absolute;
  bottom: 20px;
  left: 50%;
  display: grid;
  width: 25px;
  height: 38px;
  place-items: start center;
  padding-top: 7px;
  border: 1px solid #a9c5c8;
  border-radius: 99px;
  transform: translateX(-50%);
}
.scroll-down span {
  width: 3px;
  height: 7px;
  border-radius: 5px;
  background: var(--teal-dark);
}

.section {
  padding: 88px 0;
}
.about-section {
  background: #fff;
}
.about-layout {
  display: grid;
  grid-template-columns: 1.05fr 0.95fr;
  align-items: center;
  gap: clamp(2rem, 6vw, 5rem);
}
.section-copy h2,
.section-heading h2 {
  margin: 0.4rem 0 0.85rem;
  color: var(--ink);
  font-size: clamp(1.8rem, 3.3vw, 2.7rem);
  font-weight: 900;
  line-height: 1.4;
}
.section-copy h2 em,
.section-heading h2 em {
  color: var(--teal-dark);
  font-style: normal;
}
.section-copy p {
  margin: 0 0 0.8rem;
  color: #637583;
  line-height: 2;
}
.inline-link {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.55rem;
  color: #178b97;
  font-weight: 800;
  text-decoration: none;
}
.inline-link:hover {
  color: var(--orange);
}
.event-card {
  padding: clamp(1.2rem, 3vw, 1.8rem);
  border: 1px solid var(--line);
  border-radius: 20px;
  background: linear-gradient(145deg, #fff, #f8fcfc);
  box-shadow: 0 16px 42px rgba(34, 69, 80, 0.08);
}
.event-heading {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--line);
}
.event-symbol,
.event-icon {
  display: grid;
  flex: 0 0 auto;
  place-items: center;
  border-radius: 12px;
  background: rgba(93, 191, 201, 0.14);
  color: var(--teal-dark);
}
.event-symbol {
  width: 48px;
  height: 48px;
  font-size: 1.1rem;
}
.event-heading small,
.event-row small {
  display: block;
  color: #85929e;
  font-size: 0.72rem;
}
.event-heading h3 {
  margin: 0;
  color: #2b4151;
  font-size: 1.15rem;
  font-weight: 800;
}
.event-row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.85rem 0;
  border-bottom: 1px solid #edf1f2;
}
.event-icon {
  width: 38px;
  height: 38px;
  font-size: 0.9rem;
}
.event-row strong {
  color: #344a5a;
  font-size: 0.85rem;
}
.event-message {
  display: flex;
  gap: 0.5rem;
  margin-top: 0.9rem;
  padding: 0.7rem;
  border-radius: 10px;
  background: #fff6ef;
  color: #80634f;
  font-size: 0.76rem;
  line-height: 1.8;
}
.event-message i {
  margin-top: 0.25rem;
  color: var(--orange);
}

.video-section,
.sponsor-section {
  background: #f5fafa;
}
.section-heading {
  max-width: 700px;
  margin: 0 auto 2.2rem;
  text-align: center;
}
.section-heading p {
  margin: 0;
  color: #728291;
}
.video-stage {
  position: relative;
  display: grid;
  min-height: 390px;
  overflow: hidden;
  place-items: center;
  border: 7px solid #fff;
  border-radius: 22px;
  background: linear-gradient(125deg, #214b56, #237f88 60%, #5dbfc9);
  box-shadow: 0 18px 48px rgba(35, 82, 91, 0.17);
}
.expo-video,
.video-placeholder {
  width: 100%;
  height: 100%;
  min-height: 375px;
}
.expo-video {
  position: absolute;
  inset: 0;
  object-fit: cover;
  background: #203d46;
}
.video-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 0.55rem;
  background-position: center;
  background-size: cover;
  color: #fff;
  text-align: center;
}
.play-circle {
  display: grid;
  width: 68px;
  height: 68px;
  margin-bottom: 0.35rem;
  place-items: center;
  border: 1px solid rgba(255, 255, 255, 0.75);
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.16);
  box-shadow: 0 0 0 9px rgba(255, 255, 255, 0.08);
}
.video-placeholder strong {
  font-size: 1.25rem;
}
.video-placeholder > span:last-child {
  color: rgba(255, 255, 255, 0.82);
  font-size: 0.86rem;
}
.video-tag {
  position: absolute;
  right: 1rem;
  bottom: 1rem;
  display: flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.4rem 0.7rem;
  border: 1px solid rgba(255, 255, 255, 0.28);
  border-radius: 99px;
  background: rgba(20, 51, 58, 0.42);
  color: #fff;
  font-size: 0.72rem;
}

.booth-section {
  background: #fbfbfb;
}
.benefits-section {
  background:
    radial-gradient(ellipse at 10% 12%, rgba(93, 191, 201, 0.1), transparent 34%),
    radial-gradient(ellipse at 90% 88%, rgba(240, 134, 66, 0.08), transparent 32%),
    #f8fbfb;
}
.benefits-section .section-heading {
  margin-bottom: 1.8rem;
}
.benefits-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.9rem;
  counter-reset: benefit;
}
.benefit-card {
  position: relative;
  display: flex;
  min-height: 210px;
  overflow: hidden;
  flex-direction: column;
  padding: 1.35rem 1.2rem;
  border: 1px solid rgba(218, 231, 233, 0.9);
  border-radius: 20px;
  background: linear-gradient(155deg, #fff 58%, #f6fbfb);
  box-shadow: 0 10px 28px rgba(34, 69, 80, 0.055);
  counter-increment: benefit;
  transition:
    transform 0.2s ease,
    border-color 0.2s ease,
    box-shadow 0.2s ease;
}
.benefit-card::before {
  position: absolute;
  top: 0;
  right: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(180deg, var(--teal), rgba(93, 191, 201, 0.12));
  content: "";
}
.benefit-card:nth-child(even)::before {
  background: linear-gradient(180deg, var(--orange), rgba(240, 134, 66, 0.12));
}
.benefit-card::after {
  position: absolute;
  top: 1.15rem;
  left: 1.2rem;
  color: #a7b9bf;
  content: counter(benefit, decimal-leading-zero);
  font-size: 0.76rem;
  font-weight: 800;
  letter-spacing: 0.04em;
}
.benefit-card:hover {
  transform: translateY(-5px);
  border-color: #c9dfe1;
  box-shadow: 0 16px 34px rgba(34, 69, 80, 0.11);
}
.benefit-icon {
  display: grid;
  width: 52px;
  height: 52px;
  place-items: center;
  border: 1px solid rgba(93, 191, 201, 0.12);
  border-radius: 17px;
  background: linear-gradient(145deg, rgba(93, 191, 201, 0.2), rgba(93, 191, 201, 0.08));
  color: var(--teal-dark);
  font-size: 1.2rem;
  box-shadow: 0 6px 14px rgba(53, 146, 155, 0.08);
}
.benefit-card:nth-child(even) .benefit-icon {
  border-color: rgba(240, 134, 66, 0.12);
  background: linear-gradient(145deg, rgba(240, 134, 66, 0.2), rgba(240, 134, 66, 0.08));
  color: #d97736;
  box-shadow: 0 6px 14px rgba(190, 113, 56, 0.08);
}
.benefit-card h3 {
  margin: 1rem 0 0.35rem;
  color: #2a4050;
  font-size: 1.08rem;
  font-weight: 900;
}
.benefit-card p {
  margin: 0;
  color: #71818d;
  font-size: 0.86rem;
  line-height: 1.85;
}
@media (max-width: 900px) {
  .benefits-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
.booth-grid {
  display: grid;
  max-width: 850px;
  margin: 0 auto;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.2rem;
}
.booth-card {
  position: relative;
  overflow: hidden;
  padding: clamp(1.2rem, 3vw, 1.8rem);
  border: 1px solid var(--line);
  border-radius: 19px;
  background: #fff;
  box-shadow: 0 12px 34px rgba(34, 69, 80, 0.07);
}
.booth-card::before {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  height: 4px;
  background: var(--teal);
  content: "";
}
.booth-a::before {
  background: var(--orange);
}
.booth-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.booth-type {
  display: grid;
  width: 50px;
  height: 50px;
  place-items: center;
  border-radius: 14px;
  background: rgba(93, 191, 201, 0.14);
  color: var(--teal-dark);
  font-size: 1.4rem;
  font-weight: 900;
}
.booth-a .booth-type {
  background: rgba(240, 134, 66, 0.14);
  color: #d97736;
}
.booth-tag {
  padding: 0.2rem 0.65rem;
  border-radius: 99px;
  background: #f3f8f8;
  color: #657f84;
  font-size: 0.7rem;
  font-weight: 700;
}
.booth-card h3 {
  margin: 0.8rem 0 0.1rem;
  color: #2a4050;
  font-size: 1.3rem;
  font-weight: 900;
}
.booth-description {
  min-height: 48px;
  margin: 0;
  color: #788692;
  font-size: 0.82rem;
}
.booth-measure {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 1rem 0;
  padding: 0.65rem 0.75rem;
  border-radius: 10px;
  background: #f5f9fa;
  color: #455b6a;
}
.booth-measure i {
  color: var(--teal-dark);
}
.booth-measure strong {
  font-size: 1.1rem;
}
.booth-measure span {
  color: #82909b;
  font-size: 0.75rem;
}
.booth-price {
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
}
.booth-price strong {
  color: #263d4c;
  font-size: clamp(1.6rem, 3vw, 2.1rem);
  font-weight: 900;
}
.booth-price span {
  color: #7d8b96;
  font-size: 0.8rem;
}
.booth-includes {
  display: flex;
  align-items: flex-start;
  gap: 0.45rem;
  margin: 0.45rem 0 1rem;
  color: #647887;
  font-size: 0.76rem;
}
.booth-includes i {
  margin-top: 0.3rem;
  color: #38a07e;
}
.booth-cta {
  width: 100%;
  padding: 0.6rem 1rem;
  border: 1px solid #cfe8e9;
  background: #f1fbfb;
  color: #197c85;
}
.booth-a .booth-cta {
  border-color: #f4dfd0;
  background: #fff8f3;
  color: #c76d36;
}
.booth-cta:hover {
  background: var(--teal);
}
.booth-a .booth-cta:hover {
  background: var(--orange);
}
.booth-footnote {
  margin: 1.1rem 0 0;
  color: #7a8994;
  text-align: center;
  font-size: 0.8rem;
}
.booth-footnote i {
  color: var(--orange);
}

.sponsor-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.85rem;
}
.sponsor-card {
  display: flex;
  min-height: 154px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 0.35rem;
  padding: 0.85rem;
  border: 1px solid #e4ecee;
  border-radius: 14px;
  background: #fff;
  text-align: center;
  box-shadow: 0 5px 18px rgba(34, 69, 80, 0.04);
  transition:
    transform 180ms ease,
    border-color 180ms ease,
    box-shadow 180ms ease;
}
.sponsor-card:hover {
  transform: translateY(-3px);
  border-color: #b8d9dc;
  box-shadow: 0 10px 24px rgba(34, 69, 80, 0.09);
}
@media (max-width: 900px) {
  .sponsor-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

.sponsor-logo {
  display: flex;
  width: 100%;
  height: 78px;
  align-items: center;
  justify-content: center;
}
.sponsor-logo img {
  display: block;
  width: auto;
  max-width: min(100%, 190px);
  height: auto;
  max-height: 74px;
  object-fit: contain;
}
.sponsor-card > span {
  color: #86939e;
  font-size: 0.64rem;
}
.sponsor-card strong {
  min-height: 2.4em;
  color: #344b5a;
  font-size: 0.82rem;
  line-height: 1.5;
}

.final-cta {
  position: relative;
  padding: 58px 0;
  background: #edf9f9;
}
.final-cta-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
}
.final-cta h2 {
  margin: 0.25rem 0;
  color: #273f4e;
  font-size: clamp(1.55rem, 3vw, 2.1rem);
  font-weight: 900;
}
.final-cta p {
  margin: 0;
  color: #6d7f8c;
}
.contact-strip {
  padding: 1rem 0;
  border-top: 1px solid rgba(93, 191, 201, 0.18);
  background: #f5fbfb;
}
.contact-strip-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.7rem 1.5rem;
}
.contact-prompt {
  color: #536879;
  font-size: 0.85rem;
  font-weight: 700;
}
.contact-item {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  color: #238f9a;
  font-size: 0.88rem;
  font-weight: 800;
  text-decoration: none;
}
.contact-item:hover {
  color: #f08642;
}
.contact-item i {
  color: #f08642;
}
.footer2 {
  padding: 1.3rem 0;
  background: #203746;
  color: rgba(255, 255, 255, 0.75);
}
.footer-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}
.footer2 img {
  width: 110px;
  height: 42px;
  object-fit: contain;
}
.footer2 p,
.footer2 span {
  margin: 0;
  font-size: 0.76rem;
}

@media (max-width: 900px) {
  .main-nav {
    gap: 0.65rem;
  }
  .main-nav a {
    font-size: 0.75rem;
  }
  .hero-layout {
    gap: 0.8rem;
  }
  .hero-visual {
    min-height: 330px;
  }
}

@media (max-width: 700px) {
  .container {
    width: min(100% - 32px, 560px);
  }
  .topbar {
    padding: 8px 0;
  }
  .brand img {
    width: 105px;
    height: 42px;
  }
  .main-nav {
    display: none;
  }
  .nav-cta {
    padding: 0.45rem 0.72rem;
    font-size: 0.75rem;
  }
  .hero {
    min-height: 0;
    padding: 96px 0 52px;
  }
  .hero-layout {
    grid-template-columns: 1fr;
    gap: 0;
  }
  .hero-copy {
    text-align: center;
  }
  .hero h1 {
    font-size: clamp(2.1rem, 9vw, 3.2rem);
  }
  .hero-intro {
    margin: 0 auto;
    font-size: 0.91rem;
  }
  .hero-buttons,
  .hero-facts {
    justify-content: center;
  }
  .hero-facts {
    font-size: 0.72rem;
  }
  .hero-visual {
    min-height: 265px;
  }
  .hero-logo {
    width: min(230px, 65%);
  }
  .visual-orb {
    width: 240px;
  }
  .ring-a,
  .ring-b {
    width: 290px;
    height: 190px;
  }
  .section {
    padding: 64px 0;
  }
  .about-layout {
    grid-template-columns: 1fr;
    gap: 1.8rem;
  }
  .section-copy {
    text-align: center;
  }
  .video-stage {
    min-height: 270px;
    border-width: 5px;
    border-radius: 17px;
  }
  .expo-video,
  .video-placeholder {
    min-height: 260px;
  }
  .booth-grid {
    max-width: 440px;
    grid-template-columns: 1fr;
  }
  .benefits-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .benefit-card {
    min-height: 175px;
    padding: 1rem 0.85rem;
  }
  .benefit-icon {
    width: 44px;
    height: 44px;
    border-radius: 14px;
  }
  .benefit-card h3 {
    margin-top: 0.75rem;
    font-size: 0.95rem;
  }
  .benefit-card p {
    font-size: 0.78rem;
  }
  .booth-description {
    min-height: 0;
  }
  .sponsor-grid {
    max-width: 560px;
    margin: 0 auto;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .sponsor-card {
    min-height: 142px;
    padding: 0.7rem 0.55rem;
  }
  .sponsor-logo {
    height: 72px;
  }
  .sponsor-logo img {
    max-height: 68px;
  }
  .sponsor-card strong {
    font-size: 0.76rem;
  }
  .final-cta-inner {
    align-items: flex-start;
    flex-direction: column;
  }
  .footer-inner {
    flex-direction: column;
    text-align: center;
  }
}

@media (max-width: 380px) {
  .benefits-grid {
    grid-template-columns: 1fr;
  }
}

@media (prefers-reduced-motion: reduce) {
  .expo-page *,
  .expo-page *::before,
  .expo-page *::after {
    scroll-behavior: auto !important;
    transition-duration: 0.01ms !important;
  }
}
</style>
